module.exports = __webpack_public_path__ + "img/jira.3baf755c.jpeg";